export default "__VITE_ASSET__XYFC6NdY__"